import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { DBContext } from './DBContext'
import SherDineNav from "./SherDineNav";
import SideNav from "./SideNav";
import TopRootDiv from './TopRootDiv';
import Customer from '../assets/images/user/Customer.png';
import SalesReport from '../assets/images/user/total-sales.png';
import report from '../assets/images/user/report.png';
import Inventorymanagement1 from "./images/SideNav/Inventorymanagement1.png";

const reportCards = [
    {
        id: 'sales-report',
        title: 'Sales Report',
        description: 'Daily & date-range bill history',
        route: '/BillReport',
        color: '#0008B4',
        bg: '#EEF0FF',
        img: SalesReport,
    },
    {
        id: 'customer-details',
        title: 'Customer Ledger',
        description: 'Outstanding dues & credit history',
        route: '/CustomerDetails',
        color: '#2D7DD2',
        bg: '#EAF4FF',
        img: Customer,
    },
    {
        id: 'gst-report',
        title: 'GST / Tax Report',
        description: 'CGST, SGST & Cess breakdown',
        route: '/GSTReport',
        color: '#57BEB5',
        bg: '#EDFAF9',
        img: report,
    },
    {
        id: 'item-sales',
        title: 'Item-wise Sales',
        description: 'Top-selling items & revenue by dish',
        route: '/ItemSalesReport',
        color: '#AE59DC',
        bg: '#F5EEFF',
        img: Inventorymanagement1,
    },
    {
        id: 'staff-report',
        title: 'Staff Performance',
        description: 'Revenue, bills & avg order per waiter',
        route: '/StaffPerformance',
        color: '#E8821A',
        bg: '#FFF3E8',
        img: SalesReport,
    },
    {
        id: 'item-reports',
        title: 'Item Reports',
        description: 'Aggregated item sales and growth metrics',
        route: '/ItemReports',
        color: '#63B946',
        bg: '#F0FFF0',
        img: report,
    },
    {
        id: 'audit-log',
        title: 'Audit Log',
        description: 'System events & activity trail',
        route: '/EventViewer',
        color: '#c30000',
        bg: '#FFF0F0',
        img: report,
    },
];

function Report() {
    const [sideNav, setSideNav] = useState(false);
    const [falseState, setFalseState] = useState(null);
    const navigate = useNavigate();

    return (
        <div className='w-screen h-screen hidden sm:flex sm:flex-col overflow-hidden'>
            <SherDineNav sideNav={(state) => setSideNav(state)} falseState={falseState} />
            <div className='w-full bg-[#f5f5f5] flex-grow flex gap-3 overflow-hidden'>
                <div className='w-max h-full z-[9999]'>
                    <SideNav focus={'Report'} state={sideNav} falseState={(state) => setFalseState(state)} />
                </div>
                <div className='w-full h-full flex flex-col pr-3 pl-0 pb-3 pt-0 gap-3 overflow-hidden'>
                    <div className="pr-3 h-max w-full bg-[#fff] borderBottom">
                        <TopRootDiv image={'Report'} root={['Report']} />
                    </div>
                    <div className='w-full h-full overflow-auto p-3 font-nunito'>
                        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4'>
                            {reportCards.filter(card => card.id !== 'audit-log' || localStorage.getItem('userName') === 'shersoft' || localStorage.getItem('USER') === 'shersoft').map((card) => (
                                <div
                                    id={card.id}
                                    key={card.id}
                                    className='relative flex items-center bg-[#fff] rounded-xl gap-4 cursor-pointer p-4 shadow-sm border border-[#EBEBEB] hover:shadow-md hover:-translate-y-0.5 transition-all duration-200'
                                    onClick={() => navigate(card.route)}
                                >
                                    <div
                                        className='w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0'
                                        style={{ backgroundColor: card.bg }}
                                    >
                                        <img className='w-8 h-8 object-contain' src={card.img} alt={card.title} />
                                    </div>
                                    <div className='flex flex-col gap-0.5'>
                                        <span className='text-[1rem] font-[600] text-[#464255]'>{card.title}</span>
                                        <span className='text-[.8rem] text-[#8A8A8A]'>{card.description}</span>
                                    </div>
                                    {card.badge && (
                                        <span className='absolute top-3 right-3 text-[.65rem] font-bold px-2 py-0.5 rounded-full bg-[#f5f5f5] text-[#999]'>
                                            {card.badge}
                                        </span>
                                    )}
                                    <div
                                        className='absolute bottom-0 left-0 h-[3px] rounded-b-xl w-full'
                                        style={{ backgroundColor: card.color, opacity: 0.3 }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Report

